import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import { DocumentMetasV } from "@/types/document";

export async function fetchAvailableDocuments({
  search = "",
  postType = "",
  sortBy = ""
}: {
  search?: string;
  postType?: string;
  sortBy?: string;
}) {
  return makeWordPressAjaxRequest({
    action: "breakdance_get_available_documents_with_search",
    dataToPost: {
      search,
      postType,
      sortBy
    },
    decoder: DocumentMetasV,
    resultKey: "data"
  });
}
